// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19dvQ","type":"styles_type__6YTz4","choices":"styles_choices__Dn7dU"};